import * as dateAndTime from "date-and-time";
import { DifficultyInfo } from "../../domain/model/Question";
import { TFunction } from "i18next";
import { COLOR_GREEN } from "../../data/colors/Colors";
import SharedPreferences from "./SharedPreferences";
import { STORAGE_KEYS } from "../../data/constant/Constants";
import { SchoolType } from "../../domain/model/User";

export function formateDate(
  date: Date,
  formatText: string = "DD MMM YYYY hh:mm A",
) {
  return dateAndTime.format(new Date(date), formatText);
}

export function capitalizeFirstLetters(str: string) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}

export function getDifficultyInfo(
  difficulty: string,
  t: TFunction<"translation", undefined>,
  schoolType?: SchoolType,
): DifficultyInfo {
  if (difficulty == "Easy") {
    return {
      color: COLOR_GREEN,
      point:
        schoolType == SchoolType.PRIMARY
          ? 50
          : schoolType == SchoolType.MIDDLE_AND_HIGH_SCHOOL
            ? 200
            : 0,
      text: t("easy"),
    };
  } else if (difficulty == "Medium") {
    return {
      color: "#FFBF00",
      point:
        schoolType == SchoolType.PRIMARY
          ? 100
          : schoolType == SchoolType.MIDDLE_AND_HIGH_SCHOOL
            ? 400
            : 0,
      text: t("medium"),
    };
  } else {
    return {
      color: "red",
      point:
        schoolType == SchoolType.PRIMARY
          ? 200
          : schoolType == SchoolType.MIDDLE_AND_HIGH_SCHOOL
            ? 600
            : 0,
      text: t("hard"),
    };
  }
}

export function formattedTime(timeInSecond: number) {
  const sec = timeInSecond % 60;
  const min = Math.floor(timeInSecond / 60);
  const minute = min.toString().length <= 1 ? `0${min}` : `${min}`;
  const second = sec.toString().length <= 1 ? `0${sec}` : `${sec}`;
  return `${minute} : ${second}`;
}

export function getUserInfoAgain() {
  SharedPreferences.setNumber(
    STORAGE_KEYS.SHOULD_FETCH_PLAYER_AGAIN,
    new Date().getMilliseconds(),
  );
}

export function showGlobalLoadingView(show: boolean) {
  SharedPreferences.setBoolean(STORAGE_KEYS.SHOW_LOADING, show);
}

export function openLink(link: string, target: "_self" | "_blank" = "_self") {
  window.open(link, target, "noopener,noreferrer");
}

export const toLatinDigits = (s: string) =>
  s
    .replace(/[٠-٩]/g, (d) => "0123456789"["٠١٢٣٤٥٦٧٨٩".indexOf(d)])
    .replace(/[۰-۹]/g, (d) => "0123456789"["۰۱۲۳۴۵۶۷۸۹".indexOf(d)]);
